export default {
    'Menu': 'Menu'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/oncanvas/translations/nl.js
// module id = 433
// module chunks = 0